/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What the customer must grant in their own GCP project before Speakeasy can impersonate a service account there.
 */
export type GcpSetupInfo = {
  /**
   * The IAM role to grant Speakeasy's service account on the target service account.
   */
  requiredRole: string;
  /**
   * Speakeasy's own service account. Grant it roles/iam.serviceAccountTokenCreator on the service account you want Speakeasy to impersonate. Empty when the running environment cannot report one (local development backed by a user login rather than a service-account key).
   */
  serviceAccountEmail?: string | undefined;
};

/** @internal */
export const GcpSetupInfo$inboundSchema: z.ZodMiniType<GcpSetupInfo, unknown> =
  z.pipe(
    z.object({
      required_role: z.string(),
      service_account_email: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "required_role": "requiredRole",
        "service_account_email": "serviceAccountEmail",
      });
    }),
  );

export function gcpSetupInfoFromJSON(
  jsonString: string,
): SafeParseResult<GcpSetupInfo, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GcpSetupInfo$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GcpSetupInfo' from JSON`,
  );
}
